import { render, staticRenderFns } from "./AddShipment.vue?vue&type=template&id=ec4cc9ee&"
import script from "./AddShipment.vue?vue&type=script&lang=js&"
export * from "./AddShipment.vue?vue&type=script&lang=js&"
import style0 from "./AddShipment.vue?vue&type=style&index=0&id=ec4cc9ee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports